<template>
  <div class="ui-form-field ui-form-field--input" :class="rootClasses">
    <label>
      <span v-if="!hasFloatingLabel && $scopedSlots.label" class="ui-form-field__title-label">
        <slot name="label" />
      </span>
      <div class="ui-form-field__input-container" :data-action-count="actionCount">
        <span v-if="hasFloatingLabel && $scopedSlots.label" class="ui-form-field__floating-label">
          <slot name="label" />
        </span>
        <slot name="input">
          <input
            v-model="currentValue"
            class="ui-form-field__input"
            v-bind="$attrs"
            @focus="onFocus"
            @blur="onBlur"
            v-on="$listeners"
          />
        </slot>
        <ui-actions>
          <slot name="actions" />
        </ui-actions>
      </div>
    </label>
    <slot name="messages" />
  </div>
</template>

<script>
  import UiActions from '@/components/form/ui-actions/ui-actions.vue'
  import { getVNodes } from '@/assets/js/util/misc/vnode'

  import bemMixin from '@/assets/js/mixin/bem'
  import rootClassesMixin from '@/assets/js/mixin/root-classes'
  import floatingLabelPropsMixin from '@/assets/js/mixin/floating-label'
  import focusBehaviourMixin from '@/assets/js/mixin/focus-behaviour'
  import currentValueMixin from '@/assets/js/mixin/current-value'
  import hasErrorsPropsMixin from '@/assets/js/mixin/has-error-props'

  export default {
    components: {
      UiActions,
    },
    mixins: [
      bemMixin('ui-form-field'),
      focusBehaviourMixin,
      rootClassesMixin,
      floatingLabelPropsMixin,
      currentValueMixin,
      hasErrorsPropsMixin,
    ],
    props: {
      value: {
        type: [Number, String],
        default: '',
      },
    },
    computed: {
      actionCount() {
        return getVNodes(this.$scopedSlots.actions).length
      },
    },
  }
</script>
